import React from 'react';

export const Edit = ({className, style, onClick}) => {
  return (
    <svg className={className} style={style} onClick={onClick} width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.5311 1.71866C15.3002 1.48877 15.0261 1.3069 14.7245 1.18356C14.423 1.06022 14.1 0.997851 13.7742 1.00006C13.4484 1.00226 13.1262 1.069 12.8264 1.19641C12.5265 1.32382 12.2548 1.50939 12.0271 1.74238L2.19963 11.5699L1 16.2498L5.67991 15.0495L15.5074 5.22199C15.7404 4.99435 15.9261 4.72278 16.0535 4.42296C16.181 4.12315 16.2477 3.80104 16.2499 3.47527C16.2521 3.1495 16.1898 2.82652 16.0664 2.52501C15.943 2.22349 15.7611 1.94943 15.5311 1.71866V1.71866Z" stroke="#111827" strokeWidth="1.01664" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};
